<template>
  <div class="page">
    <a-card title="新建拼团" :bordered="false" :bodyStyle="{paddingTop:'10px'}"
            :headStyle="{ borderBottom: '0px', fontSize: '18px' }">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules"
                    :label-col="currentFormLayout.labelCol"
                    :wrapper-col="currentFormLayout.wrapperCol"
      >
        <a-form-model-item label="关联商品" prop="productId">
          <a-row>
            <a-button @click="showSelectedDialog = true" :disabled="groupId!=0" style="margin-right:15px;">选择
            </a-button>
            <!--            <span>暂不支持景酒、自由行、签证、门票、酒店类型的商品</span>-->
          </a-row>
          <a-row v-if="ruleForm.productId">
            <span>产品ID：{{ ruleForm.productId }} &nbsp;&nbsp;</span>
            <span>产品名称：{{ ruleForm.productName }}</span>
          </a-row>
        </a-form-model-item>
        <a-form-model-item label="拼团套餐" required>
          <div>仅可对已存在的套餐或价格日期设置拼团价格及规则</div>
          <custom-page-table
            ref="tableList"
            :queryParams="queryParams"
            :columns="getProductColumns()"
            :request-promise="getListPromise"
          >
            <template slot="statusSlot" slot-scope="rowItem">{{ rowItem.text|getProOptionStatusStr }}</template>
            <span slot="action" slot-scope="rowItem">
              <a @click="confirmUpdate(rowItem.record.optionId)">拼团设置</a>
            </span>
          </custom-page-table>
        </a-form-model-item>
        <a-form-model-item label="状态" prop="status">
          <a-radio-group v-model="ruleForm.status">
            <a-radio :value="0">未发布</a-radio>
            <a-radio :value="1">已发布</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">保存设置</a-button>
        </a-form-model-item>
      </a-form-model>
      <!-- 选择产品 -->
      <selected-product-dialog
        ref="dialogTable"
        :show="showSelectedDialog"
        :itemNames="['search_proId','search_proName']"
        :query-params="selectedQueryParams"
        :request-promise="getGoodsRequest"
        @close="showSelectedDialog=false"
        :columns="getGoodsColumns()"
      >
        <a-form-item label="商品ID" slot="search_proId" v-bind="currentDialogLayout">
          <a-input v-model="selectedQueryParams.proId" style="width: 170px" placeholder="请输入商品ID"></a-input>
        </a-form-item>
        <a-form-item label="商品名称" slot="search_proName" v-bind="currentDialogLayout">
          <a-input v-model="selectedQueryParams.proName" style="width: 170px" placeholder="请输入商品名称"></a-input>
        </a-form-item>
        <template slot="customIndex" slot-scope="rowItem">{{ rowItem.index + 1 }}</template>
        <template slot="proCatalogId" slot-scope="rowItem">{{ rowItem.text|productTypeName }}</template>
        <template slot="action" slot-scope="rowItem">
          <a-button type="primary" @click="onSelectedResult(rowItem.record)">选择</a-button>
        </template>
      </selected-product-dialog>
      <!-- 百货、抢购 -->
      <a-modal title="拼团设置" :visible="popupVisible" :width="modalWidth" :footer="null" @cancel="handleAddCancel">
        <a-row class="row-price">
          <a-col :span="15" style="position: relative" v-if="ruleForm.categoryId==73||ruleForm.categoryId==74">
            <!-- <div class="show-color">
              <div class="type-color">
                <div class="action green"></div>
                <span>可设置拼团</span>
              </div>
              <div class="type-color">
                <div class="action red"></div>
                <span>已设置拼团</span>
              </div>
            </div> -->
            <a-calendar :mode="mode" @panelChange="onPanelChange" @select="onDateSelected"
                        :disabledDate="disabledDateCalendar">
              <div class="price-content" slot="dateCellRender" slot-scope="value">
                <a-checkbox v-if="!isDisabledDate(value)&&!disabledDateCalendar(value)"
                            class="item-checkbox" :checked="isSelected(value)"
                            style="width: 40px">
                </a-checkbox>
                <div class="price-text" v-for="(item,index) in getListData(value)" :key="index">{{ item.content }}</div>
              </div>
            </a-calendar>
          </a-col>
          <a-col :span="ruleForm.categoryId==73||ruleForm.categoryId==74?9:20">
            <a-form-model :model="dataForm" ref="dataForm" :rules="dataRules"
                          :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
              <a-form-model-item label="拼团同行价" prop="togetherPartPrice">
                <a-input v-model="dataForm.togetherPartPrice" placeholder="请输入拼团价" :maxLength="20"/>
              </a-form-model-item>
              <a-form-model-item label="拼团价" prop="togetherPrice">
                <a-input v-model="dataForm.togetherPrice" placeholder="请输入拼团价" :maxLength="20"/>
              </a-form-model-item>
              <a-form-model-item label="拼团佣金" prop="togetherCommission">
                <a-input v-model="dataForm.togetherCommission" placeholder="请输入拼团佣金" :maxLength="20"/>
              </a-form-model-item>
              <a-form-model-item label="起拼人数" prop="togetherPersonCount">
                <a-input v-model.number="dataForm.togetherPersonCount" placeholder="2-10" :maxLength="2" suffix="人"
                         style="max-width:400px;"/>
              </a-form-model-item>
              <a-form-model-item label="拼团截止日期" prop="groupCloseDate">
                <a-date-picker
                  format="YYYY-MM-DD HH:mm:ss"
                  show-time
                  :disabled-date="disabledDate"
                  v-model="dataForm.groupCloseDate"
                  @change="onDateChange"
                />
              </a-form-model-item>
              <a-form-model-item :wrapper-col="{ span: 18, offset: 6 }">
                <a-button type="primary" @click="onSubmit" :loading="submitPriceLoading">保存设置</a-button>
                <a-popconfirm v-if="selectedDateList && selectedDateList.length>0" style="margin-left: 10px"
                              title="是否要删除当前价格？" @confirm="deleteEvent">
                  <a-button type="danger" :loading="delLoading">删除</a-button>
                </a-popconfirm>
              </a-form-model-item>
            </a-form-model>
          </a-col>
        </a-row>

      </a-modal>
    </a-card>
  </div>
</template>

<script>
import moment from 'moment'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'

export default {
  name: 'NewGroup',
  components: {
    SelectedProductDialog
  },
  data() {
    var checkAdvicePrice = (rule, value, callback) => {
      setTimeout(() => {
        if (Number(value) < Number(this.dataForm.togetherPartPrice)) {
          callback(new Error('拼团价大于或等于拼团同行价'))
        } else {
          callback()
        }
      }, 400)
    }
    var checkCommissionPrice = (rule, value, callback) => {
      setTimeout(() => {
        if (Math.round(Math.round(Number(this.dataForm.togetherPrice) * 100) - Math.round(Number(this.dataForm.togetherPartPrice) * 100) - Math.round(Number(value) * 100)) / 100 < 0) {
          callback(new Error('必须小于拼团价减拼团同行价'))
        } else {
          callback()
        }
      }, 400)
    }
    var checkPrice = (rule, value, callback) => {
      setTimeout(() => {
        if (Number(value) > 100000) {
          callback(new Error('最大设置金额100000元'))
        } else {
          callback()
        }
      }, 400)
    }
    return {
      moment,
      proId: this.$route.query.proId,
      groupId: this.$route.query.groupId,
      showSelectedDialog: false,
      submitLoading: false,
      submitPriceLoading: false,
      popupVisible: false,
      delLoading: false,
      currentDialogLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      queryParams: {
        proId: ''
      },
      selectedQueryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        proId: '',
        proName: ''
      },
      currentFormLayout: {
        labelCol: {
          xxl: { span: 3 },
          xl: { span: 3 },
          lg: { span: 3 },
          sm: { span: 3 },
          md: { span: 5 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 21 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 21 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 21 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 21 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 16 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 14 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        },
        offsetCol: {
          xxl: { offset: 3 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { offset: 3 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { offset: 3 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { offset: 3 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { offset: 5 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { offset: 10 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      ruleForm: {
        productName: '',
        categoryId: 0,
        id: null,
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId,
        productId: '',
        productName: '',
        status: 0,
        togetherSkuCount: ''
      },
      rules: {
        productId: [
          { required: true, message: '请选择关联商品', trigger: ['blur', 'change'] }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      },
      daysList: [],
      dataForm: {
        togetherPrice: '',
        togetherCommission: '',
        togetherPartPrice: '',
        togetherPersonCount: '',
        groupCloseDate: undefined,
        togetherEndTime: '',
        togetherId: null,
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId,
        priceDate: '',
        optionId: '',
        categoryId: '',
        productId: ''
      },
      modalWidth: '600px',
      dataRules: {
        togetherPartPrice: [
          { required: true, message: '请输入拼团同行价', trigger: 'blur' },
          {
            pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/,
            message: '请输入正确的金额',
            trigger: 'blur'
          },
          { validator: checkPrice, trigger: 'blur' }
        ],
        togetherPrice: [
          { required: true, message: '请输入拼团价', trigger: 'blur' },
          {
            pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/,
            message: '请输入正确的金额',
            trigger: 'blur'
          },
          { validator: checkAdvicePrice, trigger: 'blur' },
          { validator: checkPrice, trigger: 'blur' }
        ],
        togetherCommission: [
          { required: true, message: '请输入佣金', trigger: 'blur' },
          { pattern: /^([1-9]\d{0,9}|0)([.]?|(\.\d{1,2})?)$/, message: '请输入正确的金额', trigger: 'blur' },
          { validator: checkCommissionPrice, trigger: 'blur' }
        ],
        togetherPersonCount: [
          { required: true, message: '请输入拼团人数', trigger: 'blur' },
          { type: 'number', min: 2, max: 10, message: '请输入2-10之间的数字', trigger: 'blur' }
        ],
        groupCloseDate: [
          { required: true, message: '请选择拼团截止日期', trigger: 'change' }
        ]
      },
      disabledDate(current) {
        // Can not select days before today and today
        return current && current < moment().startOf('day')
      },
      mode: 'month',
      priceDataList: [],
      selectedDateList: [],
      monthStr: '',
      optionId: 0,
      priceFormData: '',
      submitFormData: ''
    }
  },
  watch: {
    selectedDateList: function(dateList) {
      if (dateList && dateList.length > 0) {
        //自动填充选中的第一个日期的价格
        const firstDate = dateList[0]
        this.getLogUtils().logWithTag('==selectedDateList1', firstDate)
        let selectedPriceItem = this.priceDataList.find((item, index, arr) => item.priceDate === firstDate)
        if (selectedPriceItem && selectedPriceItem.togetherPrice) {
          this.dataForm = selectedPriceItem
          this.dataForm.groupCloseDate = moment(selectedPriceItem.togetherEndTime, 'YYYY-MM-DD HH:mm:ss')
          this.getLogUtils().logWithTag('==selectedDateList2', this.dataForm)
        }
      }
    }
  },
  // watch:{
  //   'ruleForm.proId':{
  //     handler(val,oldVal){
  //       this.getLogUtils().logWithTag('查询商品套餐列表',val)
  //       this.$nextTick(()=>{
  //         this.$refs.pageList.refresh(true);
  //       })
  //     }
  //   },
  // },
  mounted() {

  },
  activated() {
    this.getLogUtils().logWithTag('拼团activated', this.proId)
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'GroupServiceList', title: '拼团商品' },
      { name: 'GroupOrderList', title: '拼团订单' }
    ])
    this.proId = this.$route.query.proId
    this.groupId = this.$route.query.groupId
    this.getShoppingData()
  },
  methods: {
    onDateChange(date, dateString) {
      this.dataForm.groupCloseDate = date
      this.dataForm.togetherEndTime = dateString
      this.dataForm = { ...this.dataForm }
      this.getLogUtils().logWithTag('日期onDateChange', this.dataForm.togetherEndTime)
    },
    handleAddCancel() {
      this.popupVisible = false
    },
    getGoodsRequest(params) {
      this.getLogUtils().logWithTag('==getGoodsRequest==', params)
      return this.getHttpServices().getProService().post('api/v2/groupBooking/getProductList', params)
    },
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      if (params.proId) {
        return this.getHttpServices().getProService().post('api/v2/groupBooking/getOptionListByProId', params)
      } else {
        return new Promise((resolve, reject) => {
          const result = {
            pageSize: 10,
            pageNo: 1,
            totalCount: 0,
            totalPage: 1,
            data: []
          }
          resolve(result)
        })
      }

    },
    //商品选择结果
    onSelectedResult(record) {
      this.getLogUtils().logWithTag('==onSelectedResult==', record)
      this.ruleForm.productId = record.proId
      this.ruleForm.productName = record.proName
      this.ruleForm.categoryId = record.proCatalogId
      this.showSelectedDialog = false
      this.$refs.ruleForm.validateField('productId', (Error) => {
      })
      this.queryParams.proId = record.proId
      this.$refs.tableList.refresh(true)
    },
    getGoodsColumns() {
      return [
        {
          title: '商品ID',
          dataIndex: 'proId'
        },
        {
          title: '商品名称',
          dataIndex: 'proName'
        },
        {
          title: '商品类型',
          dataIndex: 'proCatalogName',
          width: '100px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    getProductColumns() {
      return [
        {
          title: '套餐ID',
          dataIndex: 'optionId'
        },
        {
          title: '套餐名',
          dataIndex: 'optionName'
        },
        {
          title: '状态',
          dataIndex: 'optionStatus',
          width: '100px',
          scopedSlots: { customRender: 'statusSlot' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    resetForm() {
      this.$refs.ruleForm.resetFields()
    },
    resetPriceData() {
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        this.getLogUtils().logWithTag('1dataForm', this.dataForm)
        this.dataForm = {
          togetherPrice: '',
          togetherCommission: '',
          togetherPartPrice: '',
          togetherPersonCount: '',
          groupCloseDate: undefined,
          togetherEndTime: '',
          togetherId: null,
          merchantId: this.$store.getters.userInfo.merchantId,
          platformId: this.getPlatformConfig().platformId,
          priceDate: '',
          optionId: '',
          categoryId: '',
          productId: ''
        }
        this.getLogUtils().logWithTag('2dataForm', this.dataForm)
      })
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    onSubmit() {
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          if (this.checkForm()) {
            this.submitGroupPrice()
          }
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      this.submitLoading = true
      this.getHttpServices().getServerApiService().post('shopping/together/save', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('新建拼团成功')
        setTimeout(() => {
          this.$router.push({
            name: 'GroupServiceList',
            query: {
              serverUniqueId: this.$route.query.serverUniqueId,
              updateFlag: true
            }
          })
        }, 500)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    // 获取信息
    getShoppingData() {
      if (this.proId != 0) {
        this.getHttpServices().getServerApiService().post('shopping/together/query', {
          merchantId: this.$store.getters.userInfo.merchantId,
          platformId: this.getPlatformConfig().platformId,
          productId: this.proId
        }).then(res => {
          this.getLogUtils().logWithTag('getShoppingData', res)
          this.ruleForm = res
          this.queryParams.proId = res.productId
          this.$refs.tableList.refresh(true)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      } else {
        this.ruleForm = {
          productName: '',
          categoryId: 0,
          id: null,
          merchantId: this.$store.getters.userInfo.merchantId,
          platformId: this.getPlatformConfig().platformId,
          productId: '',
          productName: '',
          status: 0,
          togetherSkuCount: ''
        }
        this.queryParams.proId = ''
        this.$refs.tableList.refresh(true)
      }
    },
    // 拼团设置
    confirmUpdate(optionId) {
      this.popupVisible = true
      this.optionId = optionId
      this.monthStr = this.monthStr ? this.monthStr : this.getDateHelper().getCurrentFormatDate('YYYY-MM')
      this.modalWidth = this.ruleForm.categoryId == 73 || this.ruleForm.categoryId == 74 ? '1100px' : '600px'
      this.resetPriceData()//先删一波数据
      if (this.ruleForm.categoryId == 73 || this.ruleForm.categoryId == 74) {
        this.modalWidth = '1100px'
        this.getProPriceInfo()
      } else {
        this.modalWidth = '600px'
        this.getPriceData()
      }
    },
    submitGroupPrice() {
      this.submitPriceLoading = true
      this.priceFormData = JSON.parse(JSON.stringify(this.dataForm))
      this.priceFormData.optionId = this.optionId
      this.priceFormData.productId = this.ruleForm.productId
      this.priceFormData.categoryId = this.ruleForm.categoryId
      this.priceFormData.togetherId = this.groupId != 0 ? this.groupId : null
      if (this.ruleForm.categoryId == 73 || this.ruleForm.categoryId == 74) {
        this.priceFormData.priceDate = this.selectedDateList.join(',')
      } else {
        this.priceFormData.priceDate = ''
      }
      delete this.priceFormData.groupCloseDate
      this.getHttpServices().getServerApiService().post('shopping/together/item/save', this.priceFormData).then(res => {
        this.getLogUtils().logWithTag('submitGroupPrice', res)
        this.$message.success('拼团价格设置成功')
        if (this.ruleForm.categoryId == 5 || this.ruleForm.categoryId == 8) {
          this.popupVisible = false
        } else {
          this.getProPriceInfo()
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitPriceLoading = false)
    },
    // 获取抢购、百货价格日历
    getPriceData() {
      this.getHttpServices().getServerApiService().post('shopping/together/item/commodity/price', {
        categoryId: this.ruleForm.categoryId,
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId,
        optionId: this.optionId,
        optionStatus: 0,
        priceDate: '',
        productId: this.ruleForm.productId
      }).then(res => {
        this.getLogUtils().logWithTag('getPriceData', res)
        if (res) {
          this.dataForm = res
          this.getLogUtils().logWithTag('3dataForm', this.dataForm)
          if (res.togetherEndTime) {
            this.dataForm.groupCloseDate = moment(res.togetherEndTime, 'YYYY-MM-DD HH:mm:ss')
          }
        } else {
          this.resetPriceData()
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getListData(value) {
      let listData = []
      const dateStr = this.getDateHelper().getFormatDate(value)
      const priceItem = this.priceDataList.find((item, index, arr) => item.priceDate === dateStr)
      // this.getLogUtils().logWithTag("拼接价格数据",priceItem)
      if (priceItem) {
        if (priceItem.togetherPartPrice) {
          listData.push({ type: 'success', content: '同行价    ¥' + priceItem.togetherPartPrice })
        }
        if (priceItem.togetherPrice) {
          listData.push({ type: 'success', content: '拼团价    ¥' + priceItem.togetherPrice })
        }
        if (priceItem.togetherCommission) {
          listData.push({ type: 'success', content: '佣金    ¥' + priceItem.togetherCommission })
        }
      }
      // this.getLogUtils().logWithTag("拼接价格数据",listData)
      return listData
    },
    disabledDateCalendar(current) {
      // this.getLogUtils().logWithTag('==disabledDateCalendar===current',current)
      const dateStr = this.getDateHelper().getFormatDate(current)
      // this.getLogUtils().logWithTag('==disabledDateCalendar===dateStr',dateStr)
      // this.getLogUtils().logWithTag('priceDataList',this.priceDataList)
      const index = this.priceDataList.findIndex((item, index, arr) => item.priceDate == dateStr)
      // this.getLogUtils().logWithTag('==disabledDateCalendar===index',index)
      return current && current < moment().startOf('day') || index < 0
    },
    //判断选项是否禁用(非当前月的数据禁用)
    isDisabledDate(value) {
      const dateStr = this.getDateHelper().formatDate(value, 'YYYY-MM')
      return dateStr !== this.monthStr
    },
    onDateSelected(date) {
      this.getLogUtils().logWithTag('==onDateSelected mode===', this.mode)
      this.getLogUtils().logWithTag('==onDateSelected date===', date)
      if (this.mode === 'year') {
        this.mode = 'month'
        this.monthStr = this.getDateHelper().formatDate(date, 'YYYY-MM')
        this.getProPriceInfo()
      } else {
        const dateStr = this.getDateHelper().getFormatDate(date)
        this.getLogUtils().logWithTag('==onDateSelected dateStr===', dateStr)
        if (this.isSelected(date)) {
          this.selectedDateList = this.selectedDateList.filter((item, index, arr) => dateStr !== item)
        } else {
          this.selectedDateList.push(dateStr)
        }
      }
      this.getLogUtils().logWithTag('==onDateSelected dateListStr===', this.selectedDateList)
    },
    isSelected(momentValue) {
      const dateStr = this.getDateHelper().getFormatDate(momentValue)
      const index = this.selectedDateList.findIndex((item, index, arr) => dateStr === item)
      return index >= 0
    },
    onPanelChange(date, mode) {
      this.mode = mode
      this.getLogUtils().logWithTag('===onPanelChange mode===', mode)
      this.getLogUtils().logWithTag('===onPanelChange date===', moment(date).format('YYYY-MM-DD'))
      if (mode === 'month') {
        this.monthStr = this.getDateHelper().formatDate(date, 'YYYY-MM')
        this.getProPriceInfo()
      }
    },
    checkForm() {
      if (this.ruleForm.categoryId == 73 || this.ruleForm.categoryId == 74) {
        if (this.selectedDateList.length < 1) {
          this.$message.error('请选择日期')
          return false
        }
      }
      return true
    },
    //获取全月的接口
    getProPriceInfo() {
      this.getHttpServices().getServerApiService().post('shopping/together/item/team/price', {
        optionId: this.optionId,
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId,
        categoryId: this.ruleForm.categoryId,
        productId: this.ruleForm.productId,
        currentDate: this.monthStr + '-01'
      }).then(res => {
        this.getLogUtils().logWithTag('getProPriceInfo', res)
        if (res) {
          this.priceDataList = res
          this.selectedDateList = []
        } else {
          this.resetPriceData()
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 删除价格信息
    deleteEvent() {
      let priceDate = this.selectedDateList.join(',')
      this.delLoading = true
      this.getHttpServices().getServerApiService().post('shopping/together/item/team/delete/price', {
        optionId: this.optionId,
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId,
        categoryId: this.ruleForm.categoryId,
        productId: this.ruleForm.productId,
        priceDate: priceDate
      }).then(res => {
        this.getLogUtils().logWithTag('deleteEvent', res)
        this.$message.success('删除日历成功')
        this.getProPriceInfo()
        this.resetPriceData()
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.delLoading = false)
    }
  }
}
</script>
<style scoped lang="less">
@import url('../../../CustomPage.less');

.ant-btn + .ant-btn {
  margin-left: 10px;
}

.maxW250 {
  max-width: 250px;
}

.pl5 {
  padding-left: 5px;
}

.pr5 {
  padding-right: 5px;
}

.price-content {
  width: 100%;

  .price-text {
    font-size: 12px;
  }
}
</style>
<style lang="less">
.row-price {
  .show-color {
    display: flex;
    align-items: center;
    position: absolute;
    left: 10px;
    top: 15px;
    z-index: 100;

    .type-color {
      display: flex;
      align-items: center;
      margin-right: 10px;

      .action {
        width: 30px;
        height: 15px;
        margin-right: 5px;
      }

    }
  }

  .selected-color {
    background-color: #e6f7ff;
  }

  .ant-card-body {
    padding-top: 1px;
  }

  .item-checkbox {
    position: absolute;
    top: 6px;
    width: 16px !important;
    height: 16px;
    line-height: 16px;
  }

  .ant-fullcalendar table {
    height: 100px;
  }

  .ant-fullcalendar-fullscreen .ant-fullcalendar-month, .ant-fullcalendar-fullscreen .ant-fullcalendar-date {
    height: 100px;
  }

  .ant-fullcalendar-fullscreen .ant-fullcalendar-content {
    height: 70px;
  }

  .ant-checkbox-inner {
    border: 1px solid #40a9ff;
  }

  .red {
    background-color: rgba(245, 34, 45, 1);
    color: #FFFFFF;
  }

  .green {
    background-color: rgba(0, 238, 32, 1);
    color: #FFFFFF;
  }
}
</style>